import axios from 'axios';
import { Message } from 'element-ui';
import xui from '@/xc-ui'

// console.log('loading',xui.loading);

const instance = axios.create({
    baseURL: localStorage.apiUrl || process.env.VUE_APP_API,
    // 成功消息提示
    successMsg: false,
    // 错误消息提示
    errorMsg: true,
    // 是否需要登录
    needLogin: true,
    // loading
    showLoading: null,
    // headers
    headers: {}
});

// instance.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

instance.interceptors.request.use(
    config => {

        const token = localStorage.token;

        config = {
            ...config,
            headers: {
                token,
                ...config.headers,
            }
        };

        const { successMsg, errorMsg, showLoading, needLogin } = config;


        if (needLogin && !token) return goLogin();

        // if (showLoading) config.loadingInstance = Loading.service({
        //     lock: true,
        //     text: typeof showLoading == 'string' ? showLoading : 'Loading',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.7)'
        // });

        if (showLoading) config.loadingInstance = xui.loading({
            text: typeof showLoading == 'string' ? showLoading : '加载中...',
        })

        if (config.headers['Content-Type'] == undefined) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
            config.transformRequest = [function (data) {
                let ret = '';
                for (let key in data) {
                    let item = data[key];
                    //过滤null以及undefined by yc
                    if (item == null || item == undefined) {
                        item = ""
                    }
                    ret += encodeURIComponent(key) + '=' + encodeURIComponent(item) + '&'
                }
                return ret
            }]
        }

        config.onSuccess = (res) => {
            if (showLoading) config.loadingInstance.close();
            if (successMsg) Message.success(res.msg)
            return Promise.resolve(res);
        }

        config.onFail = (error, res) => {
            if (showLoading) config.loadingInstance.close();
            if (errorMsg) Message.error(error)
            return Promise.reject([error, res]);
        }

        return config;
    },
    error => {
        Message.error({ message: '请求超时!' });
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {

        const { config } = response;

        if (config.showLoading) config.loadingInstance.close();

        const { status, data } = response;

        if (status && status == 200) {

            //如果是文件流直接成功返回
            if (data instanceof Blob) {
                return config.onSuccess(data);
            }

            if (data.code == 0) {
                return config.onSuccess(data);
            } else {
                if (data.code == 401 || data.code == 402) {
                    // setTimeout(() => {
                    //     goLogin();
                    // }, 500);
                    goLogin();
                }

                return config.onFail(data.msg, data);
            }

        } else {
            return config.onFail('数据解析异常', data);
        }
    },
    error => {
        const { config, response } = error;

        if (response) {

            let message;
            if (response.status == 504 || response.status == 404) {
                message = '服务器异常';
            } else if (response.status == 403) {
                message = '权限不足,请联系管理员!';
            } else {
                message = '未知错误!';
            }

            return config.onFail(message, response.data);
        } else {
            if (config) {
                return config.onFail(error.message, error);
            } else {
                return Promise.reject([error.message, error])
            }

        }
    }
)

function goLogin() {
    localStorage.removeItem('token');
    location.href = process.env.VUE_APP_ADMIN_PATH + '/login';
}

export default instance;
